import config from '../../config';

export default {
  url: `${config.api.baseURL}/roles`,
  transformer(data) {
    return data;
  }
};
